import { ContentHeader } from "../components/ContentHeader";
import { SCAFFOLDS } from "./scaffolds";

/**
 * Renders a "planned" observability domain (Wave-2): a clear gated state explaining the
 * dependency, plus a preview of the intended panels. Swap the route for the real tab +
 * API module once `spec.dependency` is connected.
 */
export function ScaffoldTab({ slug }: { slug: string }) {
  const spec = SCAFFOLDS[slug];
  if (!spec) return <div className="empty">Unknown section.</div>;

  return (
    <>
      <ContentHeader title={spec.title} description={spec.desc} />

      <div className="scaffold-hero">
        <span className="scaffold-badge">Planned · {spec.phase}</span>
        <p className="scaffold-dep">
          Lights up when connected: <strong>{spec.dependency}</strong>
        </p>
      </div>

      <div className="section-header">
        <h2>Planned panels</h2><span className="count">{spec.panels.length}</span>
      </div>
      <div className="grid">
        {spec.panels.map((p) => (
          <div key={p} className="card scaffold-panel" aria-disabled="true">
            <div className="card-head">
              <div className="card-name" style={{ fontFamily: "var(--font-sans)" }}>{p}</div>
              <span className="planned-tag">soon</span>
            </div>
            <div className="scaffold-skeleton" />
          </div>
        ))}
      </div>
    </>
  );
}
